import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 引入一级路由
import Index from '@/views/home/index'; // 首页
import Toxcx from '@/views/home/toXcx'; // 跳转到小程序

const router = new VueRouter({
  mode:"history",
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      // 首页
      path: '/index',
      name: 'index',
      meta:{
        title:'首页',
      },
      component: Index,
    },
    {
      // 首页
      path: '/toXcx',
      name: 'toXcx',
      meta:{
        title:'跳转小程序',
      },
      component: Toxcx,
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js